import React, { useContext } from "react"

import { Button } from "reactstrap"

import { ScenarioContext } from "../../contexts/ScenarioContext"

export default function SaveScenarioButton({label}) {
    const { setShowScenarioComplete } = useContext(ScenarioContext)

    return (
        <Button
            size="sm"
            color="danger"
            onClick={() => setShowScenarioComplete(true)}
            className="navbar-btn"
        >
            {label}
        </Button>
    )
}
